import PropTypes from 'prop-types';
import React from 'react';
import { InputText } from 'primereact/inputtext';
import { ErrorMessage } from 'formik';

const AnswerField = ({ field, form: { touched, errors }, ...props }) => (
  <div>
    <InputText
      {...field}
      {...props}
      className={touched[field.name] && errors[field.name] ? 'p-error' : ''}
      style={{ marginRight: '.25em' }}
    />
    <br />
    <ErrorMessage name={field.name} component="small" style={{ color: 'red' }} />
  </div>
);

AnswerField.propTypes = {
  field: PropTypes.objectOf(PropTypes.any).isRequired,
  form: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default AnswerField;
